import config from '../config/app.config';

const API_BASE = config.api.baseURL.replace(/\/api\/?$/, '');

export const isAbsoluteUrl = (value) => typeof value === 'string' && /^https?:\/\//i.test(value);

export const buildClipUrl = (snippetPath) => {
  if (!snippetPath) {
    return null;
  }
  if (isAbsoluteUrl(snippetPath)) {
    return snippetPath;
  }
  const normalized = snippetPath.startsWith('/') ? snippetPath : `/${snippetPath}`;
  const withMedia = normalized.startsWith('/media/') ? normalized : `/media${normalized}`;
  return `${API_BASE}${withMedia}`;
};

const mediaUtils = {
  buildClipUrl,
  isAbsoluteUrl,
};

export default mediaUtils;
